import { useState } from 'react'

import { TaskTypeList, TaskTypeListItem } from '../../../Task'
import { Container } from '../../Container'

import { TASK_TYPE_ITEMS } from './TasksType.mocks'

function TasksType() {
  const [item, setItem] = useState(null)

  return (
    <>
      <Container label='Task type list item'>
        <TaskTypeListItem {...TASK_TYPE_ITEMS[0]} />
      </Container>
      <Container label='Task type list'>
        <TaskTypeList items={TASK_TYPE_ITEMS} value={item} onClick={setItem} />
      </Container>
    </>
  )
}

export default TasksType
